import { Collection } from 'modules/core/lib/mobx-rest'

import Audit from 'modules/audit_log/store/models/Audit'

class Audits extends Collection<Audit> {
  get cacheKey(): string {
    return 'audits'
  }

  model() {
    return Audit
  }
}

const singleton: Audits = new Audits()

export default singleton
